export const AWS_EC2_PRICING =  'awsEC2Pricing';
export const AWS_EC2_RIGHT_SIZE = 'awsEC2RightSize';
export const AWS_LABOR_SUPPORT = 'awsLaborSupport';
export const AWS_NETWORK = 'awsNetwork';
export const AWS_OPTIMIZATION_LICENSING = 'awsOptimizationAndLicensing';
export const AWS_RDS_LICENSE = 'databaseLicense';
export const AWS_RDS_PRICING = 'awsRDSPricing';
export const AWS_RDS_RIGHT_SIZE = 'awsRDSRightSize';
export const AWS_STORAGE = 'awsStorage';
export const DATABASE_LICENSE = 'databaseLicense';
export const DATABASE_MIGRATION_EFFORT = 'databaseMigrationEffort';
export const GENERAL_STORAGE = 'generalStorage';
export const MAINFRAME = 'mainframe';
export const MAINFRAME_MIGRATION_COST =  'mainframeMigrationCost';
export const MAINFRAME_ON_PREM = 'mainframeOnPrem';
export const MIGRATION_LEVEL_OF_EFFORT = 'migrationLevelOfEffort';
export const MIGRATION_TOOLS_AND_SCHEDULE =  'migrationToolsAndSchedule';
export const ON_PREM_ADMIN = 'onPremAdmin';
export const ON_PREM_DISCOUNT = 'onPremDiscount';
export const ON_PREM_IT_OPERATION = 'onPremITOperation';
export const ON_PREM_NETWORK = 'onPremNetwork';
export const ON_PREM_POWER = 'onPremPower';
export const ON_PREM_SERVER_COST = 'onPremServerCost';
export const ON_PREM_SOFTWARE = 'onPremSoftware';
export const ON_PREM_STORAGE = 'onPremStorage';
export const TCO_ASSUMPTIONS = 'tcoAssumptions';
export const VMWARE_CLOUD = 'vmwareCloud';
